import { Button } from '@ui';
import { useTranslation } from 'react-i18next';
import { CommitResult } from './types';

interface Props {
    result: CommitResult;
    onClose: () => void;
}

/** Shown after the commit: what was created, merged, skipped and what failed. */
const ResultSummary = ({ result, onClose }: Props) => {
    const { t } = useTranslation('bookings');

    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <p className="tw-m-0">
                {t('booking.createMember.summary.headline', {
                    created: result.created.length,
                    merged: result.merged.length,
                    skipped: result.skipped.length
                })}
            </p>

            {result.created.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm">{t('booking.createMember.summary.created')}</h4>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.created.map((member) => (
                            <li key={member.id}>{member.name}</li>
                        ))}
                    </ul>
                </section>
            )}

            {result.merged.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm">{t('booking.createMember.summary.merged')}</h4>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.merged.map((member) => (
                            <li key={member.id}>{member.name}</li>
                        ))}
                    </ul>
                </section>
            )}

            {result.failed.length > 0 && (
                <section>
                    <h4 className="tw-m-0 tw-text-sm tw-text-error">{t('booking.createMember.summary.failed')}</h4>
                    <ul className="tw-m-0 tw-pl-4">
                        {result.failed.map((failure) => (
                            <li key={failure.booking_id}>
                                #{failure.booking_id}: {failure.message}
                            </li>
                        ))}
                    </ul>
                </section>
            )}

            <Button onPress={onClose}>{t('booking.createMember.summary.close')}</Button>
        </div>
    );
};

export default ResultSummary;
